import React, {Component} from 'react';
import {connect} from 'react-redux';
import api from '../../utils/api';
import moment from 'moment';
import RadioGroup from '../base/radiogroup';
import Modal from '../base/modal';

class Borradores extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loader: ' loader-box',
            borradores: [],
            modalVisible: false,
            currentItem: {},
            simulacion: {
                name: '',
                type: 'PROACTIVE'
            },
            changeType: [
                {
                    id: 1,
                    name: 'Cambio proactivo',
                    active: true,
                },
                {
                    id: 2,
                    name: 'Cambio reactivo',
                    active: false,
                },
                {
                    id: 3,
                    name: 'Carga masiva',
                    active: false,
                },
            ],
        };
        this.borradores = this.borradores.bind(this);
        this.getType = this.getType.bind(this);
    }

    getType(item, removeItem) {
        this.setState({
            changeType: [
                {
                    id: 1,
                    name: 'Cambio proactivo',
                    active: removeItem.id === 1,
                },
                {
                    id: 2,
                    name: 'Cambio reactivo',
                    active: removeItem.id === 2,
                },
                {
                    id: 3,
                    name: 'Carga masiva',
                    active: removeItem.id === 3,
                }
            ],
            simulacion: {
                name: this.state.simulacion.name,
                type: removeItem.id === 1 ? 'PROACTIVE' : removeItem.id ===2? 'REACTIVE': 'MASIVE'
            }
        }, function () {
            this.refs.radio.update();
        });
    }

    borradores() {
        let _self = this;
        api.get("simulations/").then(out => {
            let _borradores = [];
            out.data.forEach(el => {
                if (el.active) {
                    let obj = {};
                    obj.id = el.id;
                    obj.name = el.name;
                    obj.date = moment(el.created).format("DD/MM/YY");
                    obj.simulation_type = el.simulation_type === "PROACTIVE" ? "Cambio Proactivo" :
                        el.simulation_type ==="REACTIVE"?"Cambio Reactivo":"Carga Masiva";
                    obj.step = el.simulation_type === "PROACTIVE" ? 3 : el.simulation_type==="REACTIVE"?4:5;
                    _borradores.push(obj);
                }
            });

            _self.setState({borradores: _borradores, loader: ''});
        })
    }

    componentDidMount() {
        this.borradores();
    }

    render() {
        let _self = this;

        let cancel = {
            text: 'CANCELAR',
            click: () => {
                _self.setState({
                    currentItem: {}
                }, () => {
                    _self.refs.modal.hide();
                });
            }
        };

        let save = {
            text: 'CONFIRMAR',
            click: () => {
                api.delete('simulations/id/' + _self.state.currentItem.id + '/').then(resp => {
                    _self.setState({loader: 'loader-box'},()=>{
                        _self.borradores();
                        _self.refs.modal.hide();});

                })
            }
        };

        let moveOn = {
            text: 'OK',
            click: () => {
                _self.refs.modalCreation.hide();
            }
        };

        return (
            <div>
                <Modal ref="modal" visible={this.state.modalVisible} save={save} cancel={cancel}>
                    <p className="red-text">Estas seguro que deseas borrar el borrador?</p>
                    <p>BORRAR BORRADOR</p>
                    <p><b>{this.state.currentItem.name}</b></p>
                    <p>{this.state.currentItem.date}</p>
                </Modal>
                <Modal ref="modalCreation" visible={this.state.modalVisible} save={moveOn}>
                    <p className="red-text">Falta poner un nombre a la simulacion nueva</p>
                </Modal>
                <section className="simulador">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col s7">
                                <div className="simulador_box">
                                    <div className="simulador_box_title">
                                        <h2>Borradores</h2>
                                    </div>
                                    <div className={"simulador_box_content " + this.state.loader}>
                                        {this.state.borradores.map((cluster, i) => {
                                            return <div key={i}>
                                                <div className="simulador_borrador">
                                                    <span
                                                        className="simulador_borrador_date">{_self.state.borradores[i].date}</span>
                                                    <span
                                                        className="simulador_borrador_name">{_self.state.borradores[i].name}</span>
                                                    <span
                                                        className="simulador_borrador_change">{_self.state.borradores[i].simulation_type}</span>
                                                    <div className="simulador_borrador_btns">
                                                        <button className="simulador_borrador_btns_trash"
                                                                onClick={() => {
                                                                    _self.setState({currentItem: _self.state.borradores[i]}, function () {
                                                                        _self.refs.modal.show();
                                                                    });
                                                                }}>
                                                            <i className="far fa-trash-alt"></i>
                                                        </button>
                                                        <button className="simulador_borrador_btns_view"
                                                                onClick={() => {
                                                                    _self.props.switchToStep(_self.state.borradores[i].step, _self.state.simulacion);
                                                                    _self.props.setEditId(_self.state.borradores[i].id)
                                                                }}>ver
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className="col s5">
                                <div className="simulador_box">
                                    <div className="simulador_box_title">
                                        <h2>Crear Nuevo</h2>
                                    </div>
                                    <div className="simulador_box_content">
                                        <div className="simulador_new-draft">
                                            <input type="text" placeholder="Nombre" onChange={ev => _self.setState({
                                                simulacion: {
                                                    name: ev.target.value,
                                                    type: _self.state.simulacion.type
                                                }
                                            })}/>
                                            <div className="row">
                                                {_self.state.changeType.map((change, i) => {
                                                    return <div key={i} className="col s6 no-gutter">
                                                        <div
                                                            className={'change-type' + (i === 0 ? ' no-border-right' : '')}>
                                                            <RadioGroup ref="radio" items={[_self.state.changeType[i]]}
                                                                        getItem={_self.getType}/>
                                                            <div className="change-name" onClick={() => {
                                                                _self.getType(null, _self.state.changeType[i])
                                                            }}>
                                                                <span
                                                                    className="change-name-main">{[_self.state.changeType[i].name]}</span>
                                                                <span className="change-name-alt">de precios</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                })}
                                            </div>
                                            <div className="simulador_new-draft_next">
                                                <div className="btn-container">
                                                    <a className="cta" onClick={() => {
                                                        if (_self.state.simulacion.name !== "") {
                                                            _self.props.switchToStep(2, _self.state.simulacion)
                                                        } else {
                                                            _self.refs.modalCreation.show();
                                                        }
                                                    }}>
                                                        <span>Siguiente
                                                            <img alt="" src="/static/imgs/angle-right.svg"/>
                                                        </span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

}

const mapStateToProps = (state) => {
    return {
        user: state.user
    }
}

export default connect(mapStateToProps)(Borradores);



// WEBPACK FOOTER //
// ./src/containers/simulador/borradores.js